import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import useSendOpenModalEvent, {
  OpenSource
} from '@/SearchResults/ResultTile/useSendOpenModalEvent';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import Tag from '../Tag';

const EvCreditTag = () => {
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const { tileData } = useTileDataContext();
  const sendOpenEvent = useSendOpenModalEvent();

  return (
    <Clickable
      data-analytics-id={null}
      className="pointer-events-auto"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        sendOpenEvent(OpenSource.EvTax);
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.EvTax,
          vehicleId: tileData.vehicleId
        });
      }}
    >
      <Tag
        tag="ev"
        text="EV Tax Credit"
        data-qa="ev-credit-tag"
        blueText
        border
      />
    </Clickable>
  );
};

export default EvCreditTag;
